export * from './menu-lateral.component';